import { Checkbox } from "../checkbox/Checkbox";

import "./MultipleChoiceQuestion.css";

import type { CheckboxChangeEvent } from "../checkbox/Checkbox";
import type { QuizQuestionChangeEvent, QuizQuestionOption } from "../../app";

export function getIntent({
  answer,
  item,
  value,
  showValidity,
}: {
  answer: string[];
  item: QuizQuestionOption;
  value?: string[];
  showValidity?: MultipleChoiceQuestionProps["showValidity"];
}) {
  if (!value || !showValidity) return;

  if (value.includes(item.value)) {
    return answer.includes(item.value) ? "success" : "error";
  }
}

export interface MultipleChoiceQuestionProps {
  answer: string[];
  options?: QuizQuestionOption[];
  isValid?: boolean;
  showValidity?: boolean;
  value?: string[];
  onChange?: (event: QuizQuestionChangeEvent) => void;
}

export function MultipleChoiceQuestion({
  answer,
  options,
  isValid,
  showValidity,
  value = [],
  onChange,
}: MultipleChoiceQuestionProps) {
  return (
    <div className="MultipleChoiceQuestion">
      {options?.map((item) => {
        const intent = getIntent({
          value,
          answer,
          item,
          showValidity,
        });

        function handleChange({ checked }: CheckboxChangeEvent) {
          const newValue = checked
            ? value.concat(item.value)
            : value.filter((v) => v !== item.value);

          onChange?.({ value: newValue });
        }

        return (
          <Checkbox
            key={item.value}
            appearance="card"
            checked={value.includes(item.value)}
            disabled={isValid}
            intent={intent}
            readOnly={isValid}
            value={item.value}
            onChange={handleChange}
          >
            {item.text}
          </Checkbox>
        );
      })}
    </div>
  );
}
